import React from 'react';
import './logo-carousel.css';

const LogoCarousel = () => {
  // List of all logo files from the client_logos folder
  const logos = [
    'capricho.png',
    'bocao.png',
    'cuquita.png',
    '8ccd00ea-3fcf-11f0-b010-021c119a7c99.png',
    'furia.png',
    'cookingmamma.png',
    'vitae.png',
    'gut.png',
    'cruce.png',
    'd9df2300-8728-11ef-a1cc-561beec36248.png',
    'c7344690-6b1c-11ef-8085-323a9f12ab1c.jpg',
    '70f71374-c955-11ef-b375-fa5b2e509727.png',
    '634d9c1a-0bd2-11f0-8f34-76c3a0fa05fe.png',
    '66c59b3a-3a86-11f0-865f-821ed960f453.jpg',
    'accounting_client_logo_flyingpumas.png',
    'accounting_client_logo_92.png',
    'accounting_client_logo_97.png',
    // 'accounting_client_logo_9.png',
    'accounting_client_logo_88.png',
    'accounting_client_logo_55.png',
    // 'accounting_client_logo_53.png',
    'accounting_client_logo_15.png',
    'accounting_client_logo_11.png',
    'accounting_client_logo_10.png',
    // 'kalabaza.png',
    'casa_madre_tierra.jpg',
    'cocina_del_nono.png',
  ];

  return (
    <section className='logo-carousel-section'>
      <div className='logo-carousel-container'>
        <div className='logo-carousel-heading'>
          <span className='logo-carousel-subtitle'>Clientes</span>
          <h2 className='logo-carousel-title'>
            Negocios que ya operan con Botón
          </h2>
        </div>

        <div className='logo-carousel-track-container'>
          <div className='logo-carousel-track'>
            {/* First set of logos */}
            {logos.map((logo, index) => (
              <div key={`logo-1-${index}`} className='logo-carousel-item'>
                <img
                  src={`/logos/client_logos/${logo}`}
                  alt={`Cliente ${index + 1}`}
                  className='logo-carousel-image'
                />
              </div>
            ))}
            {/* Duplicate set for seamless loop */}
            {logos.map((logo, index) => (
              <div key={`logo-2-${index}`} className='logo-carousel-item'>
                <img
                  src={`/logos/client_logos/${logo}`}
                  alt={`Cliente ${index + 1}`}
                  className='logo-carousel-image'
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogoCarousel;
